export default "__VITE_ASSET__CmkP9PNP__"